import React from 'react';
import { FormattedMessage } from 'react-intl';
import { Panel } from 'components/ui/index';
import classNames from 'classnames/bind';
import Logo from 'assets/images/setup-crmLogo.png';
import styles from '../index.less';

const cx = classNames.bind(styles);

const SetUpWelPage = () => (
  <Panel
    contentClasses={cx('setup-wel-container')}
  >
    <div className={cx('setup-wel-content')}>
      <img src={Logo} alt="logo" />
      <FormattedMessage id="global.crm.setup.welcome">
        {text => <p className={classNames('mt-lg', cx('wel-text'))}>{text}</p>}
      </FormattedMessage>
    </div>
  </Panel>
);

export default SetUpWelPage;



// WEBPACK FOOTER //
// ./src/views/Setup/WelcomePage/container/index.jsx